// test2273
(2273 && 0);
